import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ReportClaimIncentivesPageRoutingModule } from './report-claim-incentives-routing.module';

import { ReportClaimIncentivesPage } from './report-claim-incentives.page';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { IonicSelectableModule } from 'ionic-selectable';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReportClaimIncentivesPageRoutingModule,
    NgxDatatableModule,
    IonicSelectableModule
  ],
  declarations: [ReportClaimIncentivesPage]
})
export class ReportClaimIncentivesPageModule {}
